var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('svg',{attrs:{"id":_vm.barcodeId}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }